import { create } from 'zustand'

export interface SelectionContext {
  readonly informationNeedId: string
  readonly informationNeedDescription: string
  readonly field: string | null
}

export interface SelectionStore {
  readonly selection: SelectionContext | null
  readonly select: (context: SelectionContext) => void
  readonly clearSelection: () => void
}

export const useSelectionStore = create<SelectionStore>((set) => ({
  selection: null,
  select: (context: SelectionContext): void => set({ selection: context }),
  clearSelection: (): void => set({ selection: null }),
}))
